<template>
  <div class="nebControl"
    :style="computedStyle"
    :class="[
      { grouped, expand }
    ]"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  /**
   * Wrapper for interactive and form components. Controls rendering.
   */
  name: 'nebControl',

  props: {
    grouped: {
      type: Boolean,
      deefault: false
    },
    expand: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    computedStyle () {
      return {
        flexDirection: this.direction,
        justifyContent: this.justify,
        alignItems: this.align
      }
    }
  }
}
</script>

<style lang="scss">
.nebControl {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &.expand {
    width: 100%;
  }

  &.grouped {
    .nebControl {
      &:not(:first-child) {
        padding-left: 5px;
      }
    }
  }
}
</style>
